import React, { useEffect, useRef, useState} from "react";
import Icon from 'components/Safra/Icon';

import Button from 'components/Button'
import {FixedRating} from "components/Rating";
import {CarouselHotels} from "components/Carousel";
import SearchBarHotels from "components/Safra/SearchBarHotels";
import {useNavigate, Navigate} from "react-router-dom";
import {ModalApp} from "../../../components/Safra/Modal";
import Footer from "../../../components/Safra/Footer";

import {Container} from 'react-bootstrap'
import {
    HotelInformation,
    LocationMap,
    DivAbout,
    Paragraph,
    BoxRoom,
    Rooms,
    RoomContent,
    Rules,
} from "./styles";


import {formatCurrency} from "../../../utils/functions";
import {LoaderSearchImage} from "../../../components/Loader";
import {useApp} from "../../../contexts/AppContext";
import {useTranslation} from "../../../contexts/Safra/TranslationContext";
import {changeSelectedRoomHotelAction} from "../../../contexts/reducers/hotels/actions";

import {isChannel, usaPontos} from "../../../utils";
import {useAuth} from "../../../contexts/Safra/AuthProvider";
import {useGenialApp} from "../../../contexts/GenialAppContext";
import { trackHotelSeeAvailability, trackHotelReserveRoom, trackHotelSelectRoom } from "../../../utils/analytics";
import format from "date-fns/format";
import { subDays, isAfter } from 'date-fns';

export default function HotelPage() {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false)
    const [info, setInfo] = useState(true)
    const [infoRoom, setInfoRoom] = useState(null)

    const [checkedRoom, setCheckedRoom] = useState()

    const [modalSaldo, setModalSaldo] = useState(false)
    const [modalPontosMinimo, setModalPontosMinimo] = useState(false)

    const { hotelState, hotelDispatch } =  !isChannel('genial') ? useApp() : useGenialApp()
    const { hotel, offersHotel, travellers, datesSearchHotel, guestsSearchHotel } = hotelState
    const { balance } = useAuth();

    const [minPointsPurchase, setMinPointsPurchase] = useState(null);
    const minPoints = localStorage.getItem('minimum_points_purchase_hotel')
    const minimumPercentage = localStorage.getItem('minimum_points_payment_percentage_hotel')

    useEffect(() => {
        const syncHeight = () => {

            const height = document.body.scrollHeight;
            window.parent.postMessage(height, '*')
        };

        setTimeout(syncHeight, 1000);

    }, [])

    const scroll = useRef(null)

    const executeScroll = () => {
        scroll.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        trackHotelSeeAvailability({
            location: `${hotel.address.street}, ${hotel.address.city}`,
            check_in: datesSearchHotel?.startDate ? format(datesSearchHotel.startDate, "dd/MM/yyyy") : '',
            check_out: datesSearchHotel?.endDate ? format(datesSearchHotel.endDate, "dd/MM/yyyy") : '',
            hotel_name: hotel.name,
            hosts: (guestsSearchHotel?.adults || 0) + (guestsSearchHotel?.children || 0),
            nights: datesSearchHotel?.days,
            adults: guestsSearchHotel?.adults || 0,
            children: guestsSearchHotel?.children || 0,
            stars: hotel.stars
        });
    }

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1000)
    },[])

    window.parent.postMessage(1900, "*");

    const navigate = useNavigate()

    function handleContinue() {
        const room = hotelState.room;
        const externalProperties = JSON.parse(room?.externalProperties || '{}');
        trackHotelSelectRoom({
            points: room.amount?.points,
            hotel_name: hotel.name,
            room_name: room.name,
            location: `${hotel.address.street}, ${hotel.address.city}`,
            check_in: datesSearchHotel?.startDate ? format(datesSearchHotel.startDate, "dd/MM/yyyy") : '',
            check_out: datesSearchHotel?.endDate ? format(datesSearchHotel.endDate, "dd/MM/yyyy") : '',
            meal: room?.board?.description,
            hosts: travellers?.length,
            refund: externalProperties["Refundable"] === "True" ? 'Sim' : 'Não'
        });

        const element = document.getElementById('root')
        element.scrollIntoView({block: "start", behavior: "smooth"})
        navigate('/hotel-resume/')
    }

    function handleShowRooms(index) {
        setInfoRoom(index)
    }

    function handleInfo() {
        setInfo(!info)
    }

    const handleModalSaldo = () => {
        setModalSaldo(!modalSaldo);
    }

    const handleModalMinimoPontos = () => {
        setModalPontosMinimo(!modalPontosMinimo);
    }

    const handleReserve = (room, index) => {
        let balance = parseInt(localStorage.getItem('customer_balance'));
        let roomValue = parseInt(hotel.rooms[index].amount.points * datesSearchHotel?.days)
        let minimumPurchaseValue = parseInt((roomValue * minimumPercentage) / 100)

        setMinPointsPurchase(minimumPurchaseValue);

        if (checkedRoom === index) {
            setCheckedRoom(null)
        } else if (usaPontos() && balance < minPoints) {
            handleModalMinimoPontos()
        } else if (usaPontos() && minimumPurchaseValue > balance) {
            handleModalSaldo()
            let element = document.getElementById('root');
            element.scrollIntoView({block: "start", behavior: "smooth"})
        } else {
            let element = document.getElementById('divRegras');
            element.scrollIntoView({block: "center", behavior: "smooth"})

            hotelDispatch(changeSelectedRoomHotelAction(room))
            setCheckedRoom(index)

            const externalProperties = JSON.parse(room?.externalProperties || '{}');
            trackHotelReserveRoom({
                points: room.amount?.points,
                hotel_name: hotel.name,
                room_name: room.name,
                location: `${hotel.address.street}, ${hotel.address.city}`,
                check_in: datesSearchHotel?.startDate ? format(datesSearchHotel.startDate, "dd/MM/yyyy") : '',
                check_out: datesSearchHotel?.endDate ? format(datesSearchHotel.endDate, "dd/MM/yyyy") : '',
                meal: room?.board?.description,
                hosts: travellers?.length,
                refund: externalProperties["Refundable"] === "True" ? 'Sim' : 'Não'
            });
        }
    }

    const Room = () => {

        const totalPeople = travellers?.length;

        const getBoardTag = (boardName) => {
            if (!boardName) return null;

            const normalizedBoard = boardName.toLowerCase().replace(/\s+/g, '_');
            
            const boards = {
                'all_inclusive': { text: t('safra.hotel_page.room.boards.all_inclusive'), className: "included", icon: <Icon name="cup-soda" /> },
                'breakfast': { text: t('safra.hotel_page.room.boards.breakfast'), className: "included", icon: <Icon name="coffee" /> },
                'full_board': { text: t('safra.hotel_page.room.boards.full_board'), className: "included", icon: <Icon name="hand-platter" /> },
                'half_board': { text: t('safra.hotel_page.room.boards.half_board'), className: "included", icon: <Icon name="hand-platter" /> },
                'not_included': { text: t('safra.hotel_page.room.boards.not_included'), className: "not-included", icon: <Icon name="x" /> }
            };

            return boards[normalizedBoard] || null;
        };

        const getRoomCancellationTag = (item) => {
            const resInfo = item.reservationInfo;
            const cancelDeadline = resInfo?.cancelDeadLineDateValues;
            const today = new Date();
            let isFreeCancellation = false;
            let deadlineFormatted = '';

            const isIrrevocable = resInfo?.irrevocableGuarantee === true;
            
            const isNonRefundable = Array.isArray(resInfo?.cancellationPolicies) 
                ? resInfo.cancellationPolicies.some(policy => policy?.nonRefundable === true) : false;

            if (!isIrrevocable && !isNonRefundable && cancelDeadline) {
                const deadlineDate = new Date(
                    cancelDeadline.year,
                    cancelDeadline.month - 1,
                    cancelDeadline.day,
                    cancelDeadline.hour,
                    cancelDeadline.minutes
                );
                const freeCancellationUntil = subDays(deadlineDate, 3);
                isFreeCancellation = isAfter(freeCancellationUntil, today);
                deadlineFormatted = format(freeCancellationUntil, "dd/MM");
            }

            if (isFreeCancellation) {
                return {
                    text: t('safra.hotel_page.room.cancellation.free', { date: deadlineFormatted }),
                    className: "free-cancellation",
                    icon: <Icon name="check" />
                };
            } else {
                return {
                    text: t('safra.hotel_page.room.cancellation.non_refundable'),
                    className: "non-refundable",
                    icon: <Icon name="x" />
                };
            }
        };

        const Occupants = () => {
            let icons = [];
            for (let i = 1; i <= totalPeople; i++) {
                icons.push(<Icon name="user" key={i}/>)
            }
            return icons
        }

        return (
            <Rooms>
                { hotel.rooms.map((item, index) => {

                    const price = item?.amount?.BRL
                    const points = item?.amount?.points
                    const externalProperties = JSON.parse(item?.externalProperties)

                    return (
                        <RoomContent key={index}>
                            <p className="label">{item.name}</p>
                            <span className="price-icon">
                                {t('safra.hotel_page.room.price_for')} <Occupants/>
                            </span>

                            <div className="div-info">
                                {(() => {
                                    const boardTag = getBoardTag(item?.board?.name);
                                    if (!boardTag) return null;
                                    return (
                                        <p className={`info ${boardTag.className}`}>
                                            {boardTag.icon}
                                            <span>{boardTag.text}</span>
                                        </p>
                                    );
                                })()}
                                
                                {(() => {
                                    const tag = getRoomCancellationTag(item);
                                    return (
                                        <p className={`info ${tag.className}`}>
                                            {tag.icon}
                                            <span>{tag.text}</span>
                                        </p>
                                    );
                                })()}
                            </div>

                            <div className="row">
                                <div className="col">
                                    <div className="price">
                                        { offersHotel === "cash" && <p> { formatCurrency(price) }</p> }
                                        { offersHotel === "points" && <p> { parseFloat(points).toLocaleString() } <span>{t('safra.hotel_page.room.points')}</span> </p> }
                                        <p className="span">{t('safra.hotel_page.room.taxes_included')}</p>
                                    </div>
                                </div>
                                <div className="col">
                                    <Button width="146px" bgDisabled={checkedRoom === index ? 'var(--button-disabled-color)' : 'var(--primary-color)'} onClick={() => handleReserve(item, index)}>
                                        { checkedRoom === index ? t('safra.hotel_page.room.selected').toUpperCase() : t('safra.hotel_page.room.reserve').toUpperCase() }
                                    </Button>
                                </div>
                            </div>

                            { infoRoom === index && (
                                <div className="divText">
                                    <p className="title">{t('safra.hotel_page.room.about')}</p>
                                    <span className="paragraph">
                                       { item?.description ? item?.description : '-' }
                                    </span>
                                </div>
                            )}

                           {item.description && (
                                infoRoom === index ?
                                    <span onClick={() => setInfoRoom(null)} className="ver-mais">
                                        <span>{t('safra.hotel_page.room.hide_details')} <Icon name="chevron-up"/></span>
                                    </span>
                                :
                                   <span onClick={() => handleShowRooms(index)} className="ver-mais">
                                        <span>{t('safra.hotel_page.room.show_details')} <Icon name="chevron-down"/></span>
                                    </span>
                           )}
                        </RoomContent>
                        )
                    }
                )}
            </Rooms>
        )
    }

    const handleSearchHotels = () => {
        navigate('/hotels-search-result')
    }

    if (loading) return <LoaderSearchImage />

    if (!loading && !hotel.name) return <Navigate to="/hotels-search-result" />

    return (
        <>
            <SearchBarHotels
                info={info}
                handleInfo={handleInfo}
                searchHotels={handleSearchHotels}
            />

            { hotel.name &&
                <>
                    <Container className="container-page px-4">
                        <HotelInformation>
                            <div className="hotel">
                                <h3>{hotel.name}</h3>
                                <FixedRating value={hotel.stars}/>
                            </div>

                            <span className="map">
                                <LocationMap/>
                                {hotel.address.street}, {hotel.address.city}
                            </span>

                        </HotelInformation>

                        <CarouselHotels images={hotel.images}/>

                        <div className="mb-3" >
                            <Button type="button" onClick={executeScroll}>{t('safra.hotel_page.view_availability')}</Button>
                        </div>

                        <DivAbout>
                            <p className="sobre-hotel">{t('safra.hotel_page.about_hotel')}</p>
                            <Paragraph>
                                <div dangerouslySetInnerHTML={{__html : hotel.description }} />
                            </Paragraph>
                            <p className="quarto mb-0">{t('safra.hotel_page.rooms_title')}</p>
                            <Paragraph>{t('safra.hotel_page.rooms_subtitle')}</Paragraph>
                        </DivAbout>
                    </Container>

                    <BoxRoom>
                        <nav className="px-4">
                            <div className="nav nav-tabs border-bottom-0 d-flex gap-1" id="nav-tab" role="tablist">
                                <button
                                    className="nav-link active button-tab"
                                    id={`room-1`}
                                    data-bs-toggle="tab"
                                    data-bs-target={`#nav-room-1`}
                                    type="button"
                                    role="tab"
                                    aria-controls={`nav-room-1`}
                                    aria-selected="true"
                                >
                                    {t('safra.hotel_page.room_label')} <Icon name="circle-check"/>
                                </button>
                            </div>
                        </nav>
                        <div ref={scroll} style={{marginTop: "90px", position: "absolute"}}/>
                        <div className="tab-content" id="nav-tabContent">
                            <div

                                className={`tab-pane fade show active`}
                                id={`nav-room-1`}
                                role="tabpanel"
                                aria-labelledby={`nav-room-1-tab`}
                            >
                                <Room/>
                            </div>

                        </div>
                    </BoxRoom>

                    <Rules id="divRegras">
                        <p className="rule">{t('safra.hotel_page.establishment_rules')}</p>
                        <div className="div-check mb-3">
                            <p>
                                {t('safra.hotel_page.check_in')}
                                <span>
                                    16:00
                                </span>
                            </p>
                            <p>
                                {t('safra.hotel_page.check_out')}
                                <span>
                                    10:00
                                </span>
                            </p>
                        </div>
                        <p className="rule">{t('safra.hotel_page.cancellation_rules_title')}</p>
                        <div className="div-check mb-3">
                            <ul>
                                <li>
                                    {t('safra.hotel_page.cancellation_rule_1')}
                                </li>
                                <li>
                                    {t('safra.hotel_page.cancellation_rule_2')}
                                </li>
                            </ul>
                        </div>

                        <Button id="btnContinuar"
                            onClick={handleContinue}
                            disabled={!hotelState.room.name}
                        >
                            {t('safra.hotel_page.cta_continue')}
                        </Button>
                    </Rules>
                </>
            }

            <ModalApp id="divModal" show={modalSaldo} handleModal={handleModalSaldo} isMap={true}>
                <div className="px-4 pt-5 pb-4 d-grid">
                    <span>{t('safra.hotel_page.messages.insufficient_balance')}</span>
                    <span>{t('safra.hotel_page.messages.min_purchase_value', { min: minPointsPurchase })}</span>
                </div>
            </ModalApp>

            <ModalApp id="divModal" show={modalPontosMinimo} handleModal={handleModalMinimoPontos} isMap={true}>
                <div className="px-4 pt-5 pb-4 d-grid">
                    <span>{t('safra.hotel_page.messages.insufficient_points')}</span>
                    <span>{t('safra.hotel_page.messages.min_points_required', { min: minPoints })}</span>
                </div>
            </ModalApp>
            <Footer />
        </>
    );
}
